<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div class="login-foot" @click="openPage">鄂ICP备15003065号-2</div>
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'
import { login, logout } from '@/api/user'
export default {
  components: {
    LoginForm
  },
  methods: {
    handleSubmit (data) {
      let username = data.name
      let password = data.password
      let vm = this
      login({ username, password }).then(res => {
        let status = res.data.meta.success
        if(status){
          sessionStorage.setItem('user', username);
          vm.$router.push({
            name: vm.$config.homeName
          })
        } else {
          vm.$Message.error('用户名或密码错误')
        }
      })
    },
    openPage(){
      window.open('https://beian.miit.gov.cn')
    },
  }
}
</script>

<style>
  .login-foot {
    /*width: 349px;*/
    height: 20px;
    font-size: calc(100vw * 14 / 1920);
    font-family: OPPOSans Medium, OPPOSans Medium-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    line-height: 46px;
    position: absolute;
    top: 85%;
    left: 45%;
    cursor: pointer;
  }

</style>
